export default __webpack_public_path__ + "static/6-855d07f499c210b4c0377667fcb32c58.jpg";